// extracted by mini-css-extract-plugin
export default {"resize-animation-stopper":"ResizeAnimationStopper_resize-animation-stopper__DBnx+"};